import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { CandidateAdditionalDetails } from 'src/app/core/models/candidateAdditionalDetails';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { FourDotFiveTimeStampFormatPipe } from 'src/app/core/pipes/four-dot-five-time-stamp-format';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';
import { OutreachService } from 'src/app/core/services/outreach.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { CandidateProfile } from 'src/app/public/app/models/candidateProfile';
import { FeedbackExecutionComponentWrapper } from './feedback-execution.wrapper';
import { SharedService } from 'src/app/core/services/shared.service';
declare var Dropzone: any;
declare var $: any;
declare var libphonenumber: any;

@Component({
  selector: 'app-candidate-outreach-page',
  templateUrl: './candidate-outreach-page.component.html',
  styleUrls: ['./candidate-outreach-page.component.css']
})
export class CandidateOutreachPageComponent implements OnInit {
  @ViewChild(FeedbackExecutionComponentWrapper, {static: false}) feedbackExecutionComponentRef: FeedbackExecutionComponentWrapper;
  @ViewChild('jobMatchModal', {static: false}) jobMatchModal: TemplateRef<any>;
  @ViewChild('conflictsModal', { static: false }) conflictsModal: TemplateRef<any>;
  @Input() $transition$: any;
  showJobProfileModal: BsModalRef;
  showResumeModal: BsModalRef;
  showUploadModal: BsModalRef;
  showCandidateContactModal: BsModalRef;
  showCandidateAdditionalModal: BsModalRef;
  showJobMatchModal: BsModalRef;
  conflictsModalRef: BsModalRef;

  resumepdfUrl: SafeUrl;
  resumepdfViewUrl: SafeUrl;

  stateParams: any;
  outreachId: any = "";
  candidateName: any = "";
  loginUserDetails: any;
  outreachObject: any = {};
  jobMatches: any = [];
  candidateId: any = "";
  resumeList: any = [];
  outreachEmailResumeUploadDropzone: any;
  outreachEmailResumeUploadDropzoneModal: any;
  uploadResumesResponse: any;
  sourceType: any;
  otherSourceTypeNotes: any;
  referrerName; any = "";
  referrerEmail: any;
  jobId: any;
  jobModalId: any;
  companyId: any;
  candidate:any = new CandidateProfile();
  salaryDurationOptions: any;
  jobTypeList: any;
  jobSubTypesList: any;
  sponsorshipList: any;
  candidateContactData: any;
  activeOutreachFeedbackClientsQuestionsList: any = [];
  outreachData: any;
  companyName: any = "";
  impactedOutreachObjectData: any = {};
  outreachObjectBackup: any = {};
  tokenId: any = "";
  candidateConflictDetails: any = null;

  isAllJobMatchesSelected: boolean = false;
  fileExistsFlag: boolean = false;
  disableUploadButtonFlag: boolean = true;
  fileUploadInProgressFlag: boolean = false;
  isSingleResumeUploadDone: boolean = false;
  isSingleResumeUploadedInPreviousSession: boolean = false;
  isSubmittedFormValid: boolean = true;
  loadingFlag: boolean = false;
  isFeedbackTabActive: boolean = true;
  isJobMatchLoading: boolean = true;
  isStaffingCompany: boolean = false;
  isCandidateContactDetailsMissing: boolean = false;
  isCandidateAdditionalContactDetailsMissing: boolean = false;
  isSavedDraft: boolean = false;
  isContactInfoChanged: boolean = false;
  isAdditionalContactInfoChanged: boolean = false;
  isOutreachCompleted: boolean = false;
  isAllJobmatchesInterestedOrNotInterestedOrMaybeDisabled: boolean = false;
  outreachResultedInNoJobMatches: boolean = false;
  isOutreachQuestionsSavedInDraft: boolean = false;

  constructor(
    @Inject('$state') public $state: any,
    private authService: AuthService,
    private candidateService: CandidateService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private resumeService: ResumeService,
    public fourDotFiveTimeStampFormatPipe: FourDotFiveTimeStampFormatPipe,
    private bsModalService: BsModalService,
    private sanitizer: DomSanitizer,
    private outreachService: OutreachService,
    private utilityService: UtilityService,
    private jobService: JobService,
    private sharedService: SharedService,
    @Inject('StorageService') public StorageService: any,
  ) { }

  ngOnInit() {
    Dropzone.autoDiscover = false;
    this.stateParams = this.$transition$.params();
    this.outreachId = this.stateParams.outreachId;
    this.candidateId = this.stateParams.candidateId;
    this.tokenId = this.stateParams.tokenId;
    // this.candidateId = "5ed9129f80ee222b00872da6";
    this.companyId = this.stateParams.companyId;
    this.loginUserDetails = this.authService.getUserDetails();
    this.candidateName = this.loginUserDetails.firstname ? this.loginUserDetails.firstname : "";
    this.candidateName = this.candidateName + (this.loginUserDetails.lastname ? " " + this.loginUserDetails.lastname : "");
    this.isStaffingCompany = this.loginUserDetails.company.companyType === 'StaffingCompany';
    this.companyName = this.loginUserDetails.company.companyName;
    this.getSalaryDurationOptions();
    this.getAllPreferredJobTypes();
    this.getAllJobSubTypes();
    this.getAllSponsorshipTypes();
      this.getOutreachDetails(() => {
      this.setOutreachData(() => {
        this.isJobMatchLoading = false;
        this.resumepdfUrl = this.sanitizeUrl(this.resumeService.getResumeDownloadPdfUrl(this.candidateId));
        this.resumepdfViewUrl = this.sanitizeUrl(this.resumepdfUrl + '#view=fitH');
        setTimeout(() => {
          this.outreachEmailResumeUploadDropzone = this.createResumeUploadDropzone("form#outreachEmailResumeUploadDropzone");
        }, 1000);
        this.checkAndSetFeedbackActive();
      });

    });
  }

  getSalaryDurationOptions() {
    this.jobService.getSalaryDurationOptions((data) => {
      this.salaryDurationOptions = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllPreferredJobTypes() {
    this.jobService.getAllJobTypes((data) => {
      this.jobTypeList = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllJobSubTypes() {
    this.jobService.getAllJobSubTypes((data) => {
      this.jobSubTypesList = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllSponsorshipTypes() {
    this.jobService.getAllSponsorshipTypes((data) => {
      this.sponsorshipList = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getOutreachDetails(successCallback) { 
    this.outreachService.getOutreachFeedbackQuestions(this.candidateId, this.companyId, (data) => {
      this.outreachData = data;
      this.outreachObject = _.cloneDeep(data.candidateOutreachJobMatchesInfo);
      this.isOutreachCompleted = this.outreachData.outreachCompleted;
      this.outreachResultedInNoJobMatches = this.outreachData.outreachResultedInNoJobMatches;
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  setOutreachData(successCallback) {
    this.outreachObject.jobMatches.forEach(jobMatch => {
      jobMatch.isValid = true;
      this.outreachService.setCompanyLocationLabel(jobMatch, this.isStaffingCompany);
      jobMatch.missingOrNonMatched = this.outreachService.setMissedOrMatchedInfo(jobMatch.missingOrNonMatchedInfo, jobMatch.workLocations);
      jobMatch.workLocationsMatchStatus = this.setWorkLocationsMatchStatus(jobMatch.missingOrNonMatchedInfo.requisitionWorkLocationModes, jobMatch.workLocations);
      jobMatch.formattedOutreachStatus = this.outreachService.formatOutreachStatus(jobMatch.outreachStatus);
      jobMatch.outreachStatus = this.setOutreachStatus(jobMatch.outreachStatus);
      jobMatch.jobDetails = this.outreachService.setJobDetailsLabel(jobMatch, this.jobTypeList, this.salaryDurationOptions);
      jobMatch.daysSinceOutreach = this.outreachService.setDaysSinceOutreach(jobMatch);
      jobMatch.candidateMatch = this.outreachService.setCandidateMatchingLabel(jobMatch);
      jobMatch.isNoLongerMatch = this.outreachService.setNoLongerMatch(jobMatch.missingOrNonMatched);
    });
    this.isAllJobmatchesInterestedOrNotInterestedOrMaybeDisabled = this.outreachObject.jobMatches.every(jobMatch => jobMatch.isNoLongerMatch === true);
    this.isOutreachQuestionsSavedInDraft = this.outreachData.candidateOutreachJobMatchesInfo ? this.outreachData.candidateOutreachJobMatchesInfo.jobMatches.some(jobMatch => this.outreachService.setOutreachQuestionsSavedInDraft(jobMatch.outreachStatus)) : false;
    this._getCandidateProfile(() => {
      if (successCallback) {
        successCallback();
      }
      });
  }


  setWorkLocationsMatchStatus(jobWorkLocations, candidateWorkLocations) {
    if (!jobWorkLocations || jobWorkLocations.length === 0) {
      return "available";
    }

    if (candidateWorkLocations && candidateWorkLocations.length > 0) {
      const candidateLocationNames = candidateWorkLocations.map(loc => loc.name);

      for (let i = 0; i < jobWorkLocations.length; i++) {
        const location = jobWorkLocations[i];
        if (candidateLocationNames.includes(location)) {
          return "match";
        }
      }
    }

    return "noMatch";
  }

  _getCandidateProfile(successCallback) {
    this.loadingFlag = true;
    this.candidateService.getCandidateProfile(this.candidateId, true, (data) => {
      this.candidateContactData = data;
      _.merge(this.candidate, data);
      if (data.candidateAdditionalDetails) {
        this.candidate.candidateAdditionalDetails.workLocations = _.cloneDeep(data.candidateAdditionalDetails.workLocations);
      }
      this.candidate = this._massageCandidateData(this.candidate);
      this.candidate.profileUrlText = '';
      if (!_.isNull(this.candidate.profileUrl)) {
        if (this.candidate.profileType != 'Other') {
          this.candidate.profileUrlText = "View Candidate's " + this.candidate.profileType + " Profile";
        } else {
          this.candidate.profileUrlText = "View Candidate's Profile";
        }
      }
      this.setMissingDetailsIcons(this.candidate);
      if (this.candidateContactData.resumeUploadedByCandidateAt && !this.isSingleResumeUploadDone) {
        const uploadedAt:any = new Date(this.candidateContactData.resumeUploadedByCandidateAt);
        const now:any = new Date();
        // Difference in days
        const diffInDays = (now - uploadedAt) / (1000 * 60 * 60 * 24);
        // True if less than or equal to 30 days old
        this.isSingleResumeUploadedInPreviousSession = diffInDays <= 30;
      } else {
        this.isSingleResumeUploadedInPreviousSession = false;
      }
      setTimeout(() => {
        this.loadingFlag = false;
        if (successCallback) {
          successCallback();
        }
      }, 500);
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      // do nothing.
    });
  }

  _massageCandidateData(candidate) {
    candidate.name = candidate.firstName + ' ' + candidate.lastName;
    if (_.isNull(candidate.title)) {
      candidate.title = '-';
    }
    if (_.isNull(candidate.email)) {
      candidate.email = '-';
    }
    if (_.isNull(candidate.mobilePhone)) {
      candidate.mobilePhone = '-';
    }
    if (_.isNull(candidate.candidateAdditionalDetails)) {
      candidate.candidateAdditionalDetails = new CandidateAdditionalDetails();
    }
    candidate.candidateAdditionalDetails.candidateId = this.candidateId;

    candidate.displayAddress1 = '';
    candidate.displayAddress2 = '';
    if (_.isNull(candidate.address)) {
      candidate.displayAddress1 = '-';
      candidate.displayAddress2 = '-';
      candidate.combinedAddress = '-';
    } else {
      let address = candidate.address || {};

      let address1Parts = [];
      if (!_.isEmpty(address.address1)) address1Parts.push(address.address1);
      if (!_.isEmpty(address.address2)) address1Parts.push(address.address2);
      candidate.displayAddress1 = address1Parts.join(', ');

      let address2Parts = [];
      if (!_.isEmpty(address.city)) address2Parts.push(address.city);
      if (!_.isEmpty(address.county)) address2Parts.push(address.county);
      if (!_.isEmpty(address.state)) address2Parts.push(address.state);
      if (!_.isEmpty(address.zipCode)) address2Parts.push(address.zipCode);
      if (!_.isEmpty(address.country)) address2Parts.push(address.country);

      candidate.displayAddress2 = address2Parts.join(', ');

      candidate.combinedAddress = address2Parts.length > 0
        ? address2Parts.join(', ')
        : '-';

      candidate.location = this.setCandidateLocation(candidate.address);
    }

    candidate.displayAdditionalDetails = this.setAdditionalCandidateDetails(candidate.candidateAdditionalDetails);

    if (candidate.mobilePhoneCountryCodePresent) {
      var phoneNumberObject = libphonenumber.parse(candidate.mobilePhone.toString());
      if (phoneNumberObject.phone !== undefined) {
        candidate.mobilePhone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
      }
    }

    angular.forEach(candidate.educations, (education, key) => {
      if (_.isNull(education.instituteName) || education.instituteName === "") {
        education.instituteName = "'Unknown'";
      }

      if (education.startDate) {
        education.startDate.formattedMonth = this._getMonthByNumber(education.startDate.monthOfYear);
      }

      if (education.endDate) {
        education.endDate.formattedMonth = this._getMonthByNumber(education.endDate.monthOfYear);
      }
      this._setDateRange(education);
    });

    angular.forEach(candidate.experiences, (experience, key) => {
      if (_.isNull(experience.employerName) || experience.employerName === "") {
        experience.employerName = "'Unknown'";
      }

      if (experience.startDate) {
        experience.startDate.formattedMonth = this._getMonthByNumber(experience.startDate.monthOfYear);
      }

      if (experience.endDate) {
        experience.endDate.formattedMonth = this._getMonthByNumber(experience.endDate.monthOfYear);
      }
      this._setDateRange(experience);
    });

    candidate.isResumeFilePdf = false;
    if (candidate.resume && candidate.resume.fileName) {
      candidate.isResumeFilePdf = (candidate.resume.fileName.slice(-4)) === '.pdf' ? true : false;
    }

    return candidate;
  }

  setCandidateLocation(location) {
    if (!location.zipCode) return "-";

    let country = location.country || null;
    let state = location.state || null;
    let city = location.city || null;
    let county = location.county || null;

    if (country) {
      return state || city || county ? `${state || city || county}, ${country}` : country;
    }

    let parts = [city, state, county].filter(Boolean);
    return parts.length > 0 ? parts.join(", ") : "-";
  }

  setAdditionalCandidateDetails(additional) {
    let additionalDetails:any = {
      jobTypes: '-',
      salary: '-',
      rate: '-',
      sponsorships: '-',
      worklocations: '-',
      additionalUrls: [],
      additionalInformation: '-',
      willingToRelocate: '-'
    };
    if (additional) {
      if (additional.preferredJobTypeDetails) {
        if (additional.preferredJobTypeDetails && additional.preferredJobTypeDetails.jobType) {
          let jobTypes = [];

          additional.preferredJobTypeDetails.jobType.forEach(jobType => {
            let jobTypeObj = this.jobTypeList.find(item => item.value === jobType.jobType);
            let jobTypeName = jobTypeObj ? jobTypeObj.name : jobType.jobType;

            let jobSubTypeName = '';
            if (jobType.jobSubType) {
              let subTypeObj = this.jobSubTypesList.find(item => item.value === jobType.jobSubType);
              jobSubTypeName = subTypeObj ? ` (${subTypeObj.name})` : ` (${jobType.jobSubType})`;
            }

            jobTypes.push(jobTypeName + jobSubTypeName);
          });

          additionalDetails.jobTypes = jobTypes.join(", ");
        }

        if (additional.preferredJobTypeDetails.salary) {
          let minSalary = additional.preferredJobTypeDetails.salary.minSalary;
          let maxSalary = additional.preferredJobTypeDetails.salary.maxSalary;
          let salaryType = additional.preferredJobTypeDetails.salary.salaryType;
          let salaryDuration = this.salaryDurationOptions.find(item => item.value === additional.preferredJobTypeDetails.salary.salaryDuration).name;
          if (minSalary && maxSalary) {
            additionalDetails.salary = (salaryType && (salaryType === 'SPECIFIC')) ? `${minSalary ? minSalary : maxSalary} ` :`${minSalary} to ${maxSalary} `;
            additionalDetails.salary = additionalDetails.salary + additional.preferredJobTypeDetails.salary.currency + " " + salaryDuration;
          } else if (maxSalary || minSalary) {
            additionalDetails.salary = minSalary ? `${minSalary} ` : `${maxSalary} `;
            additionalDetails.salary = additionalDetails.salary + additional.preferredJobTypeDetails.salary.currency + " " + salaryDuration;
          }
        }

        if (additional.preferredJobTypeDetails.rate) {
          let minRate = additional.preferredJobTypeDetails.rate.minRate;
          let maxRate = additional.preferredJobTypeDetails.rate.maxRate;
          let rateType = additional.preferredJobTypeDetails.rate.rateType;
          let rateDuration = this.salaryDurationOptions.find(item => item.value === additional.preferredJobTypeDetails.rate.rateDuration).name;
          if (minRate && maxRate) {
            additionalDetails.rate = (rateType && (rateType === 'SPECIFIC')) ? `${minRate ? minRate : maxRate} ` :`${minRate} to ${maxRate} `;
            additionalDetails.rate = additionalDetails.rate + additional.preferredJobTypeDetails.rate.currency + " " + rateDuration;
          } else if (maxRate || minRate) {
            additionalDetails.rate = minRate ? `${minRate}` : `${maxRate}`;
            additionalDetails.rate = additionalDetails.rate + additional.preferredJobTypeDetails.rate.currency + " " + rateDuration;
          }
        }
      }

      if (additional.sponsorships && additional.sponsorships.length > 0) {
        let sponsorships = additional.sponsorships.map(sponsorship => {
          let match = this.sponsorshipList.find(item => item.value === sponsorship);
          return match ? match.name : sponsorship;
        });

        additionalDetails.sponsorships = sponsorships.join(", ");
      }

      if (additional.workLocations && additional.workLocations.length > 0) {
        additionalDetails.worklocations = additional.workLocations.map(location => { return location.name }).join(", ");
      }

      if (additional.urls && additional.urls.length > 0) {
        additionalDetails.additionalUrls = [...additional.urls];
      }

      if (additional.additionalInformation && additional.additionalInformation != "") {
        additionalDetails.additionalInformation = additional.additionalInformation;
      }

      if (additional.willingToRelocate && additional.willingToRelocate != "") {
        additionalDetails.willingToRelocate = this.outreachService.formatOutreachStatus(additional.willingToRelocate);
      }

    }
    return additionalDetails;
  }

  selectAllJobMatches() {
    this.isAllJobMatchesSelected = !this.isAllJobMatchesSelected;
    if (this.isAllJobMatchesSelected) {
      this.outreachObject.jobMatches.forEach(jobMatch => jobMatch.isSelected = true);
    } else {
      this.outreachObject.jobMatches.forEach(jobMatch => jobMatch.isSelected = false);
    }
  }

  checkIfAllJobMatchesSelected() {
    let jobNotSelected = [];
    jobNotSelected = this.outreachObject.jobMatches.filter(jobMatch => !jobMatch.isSelected);

    if (jobNotSelected.length > 0) {
      this.isAllJobMatchesSelected = false;
    } else {
      this.isAllJobMatchesSelected = true;
    }
  }

  /**
  * creates the resume upload drop zone.
  // */
  createResumeUploadDropzone(id) {
    let dropzoneElement = document.querySelector(id);
    if (!dropzoneElement) {
      console.error(`Dropzone element not found: ${id}`);
      return;
    }

    let outreachEmailResumeUploadDropzone = new Dropzone(dropzoneElement, {
      url: this.resumeService.getUploadUrl(),
      paramName: "file",                     
      acceptedFiles: ".pdf,.doc,.docx",
      maxFiles: 1,
      maxFilesize: 10,  
      maxThumbnailFilesize: 10,
      timeout: 300000,
      addRemoveLinks: true,
      autoProcessQueue: false,
      uploadMultiple: false
    });

    outreachEmailResumeUploadDropzone.on('addedfile', (file) => {
      this.fileExistsFlag = true;
      this.disableUploadButtonFlag = false;
      $('.dz-progress').css({ top: '70%' });
    });

    outreachEmailResumeUploadDropzone.on('removedfile', () => {
      if (this.outreachEmailResumeUploadDropzone.files.length === 0) {
        this.fileExistsFlag = false;
        $(".dz-hidden-input").prop("disabled", false);
      }
    });

    outreachEmailResumeUploadDropzone.on('sending', (file, xhr, formData) => {
      this.disableUploadButtonFlag = true;
      this.fileUploadInProgressFlag = true;

      const resumeUpload = {
        companyId: this.companyId,
        userId: this.loginUserDetails.id,
        candidateId: this.candidateId,
        buIdList: [],
        resumeSourceTypeId: "5d6fea1329945b5bd8eebbd1", // Local
        otherSourceTypeNotes: null,
        referrerName: null,
        referrerEmail: null,
        sourceScreen: 'OUTREACH'
      };

      formData.append("candidateId", resumeUpload.candidateId);
      formData.append("companyId", resumeUpload.companyId);
      formData.append("userId", resumeUpload.userId);
      formData.append("resumeSourceTypeId", resumeUpload.resumeSourceTypeId);
      formData.append("otherSourceTypeNotes", resumeUpload.otherSourceTypeNotes);
      formData.append("referrerName", resumeUpload.referrerName);
      formData.append("referrerEmail", resumeUpload.referrerEmail);
      formData.append("buIdList", JSON.stringify(resumeUpload.buIdList));
      formData.append("sourceScreen", resumeUpload.sourceScreen);
    });

    outreachEmailResumeUploadDropzone.on('success', (file, response) => {
      this.fileUploadInProgressFlag = false;
      this.uploadResumesResponse = response;

      if (response.files && response.files.length > 0) {
        response.files.forEach((val, key) => {
          if (file[key]) {
            file[key].resumeId = val.resumeId;
          }
        });
      }

      if (this.uploadResumesResponse.conflicts) {
        if (this.uploadResumesResponse.conflicts.disallowUpload) {
          this.alertsAndNotificationsService.showAlertWithCallBack('Upload Failed', this.uploadResumesResponse.conflicts.uploadBlockedMessage, 'danger', () => {
            this.utilityService.showLoadingModal('Loading...');
            this.refreshOutreach(() => {
              this.resetOutreachBackupData();
              this.utilityService.hideLoadingModal();
              // Remove any existing file(s) from the Dropzone instance to clear previews
              if (this.outreachEmailResumeUploadDropzone && this.outreachEmailResumeUploadDropzone.files && this.outreachEmailResumeUploadDropzone.files.length > 0) {
                  this.outreachEmailResumeUploadDropzone.removeAllFiles(true);
                  this.fileExistsFlag = false;
              }
            });
          });
        } else if (!this.uploadResumesResponse.conflicts.disallowUpload && this.uploadResumesResponse.conflicts.conflictExists) {
          this._showConflictsModal(this.uploadResumesResponse.conflicts);
        }
      } else {
      $(".dz-hidden-input").prop("disabled", true);
        this.isSingleResumeUploadDone = true;
        this.isSingleResumeUploadedInPreviousSession = false;
        let message = response.message ? response.message : 'Resume uploaded successfully.';
        this.alertsAndNotificationsService.showBannerMessage(message, 'success');
        this.utilityService.showLoadingModal('Loading...');
      this.refreshOutreach(() => {
        this.resetOutreachBackupData();
        this.utilityService.hideLoadingModal();
      });
      }

    });

    outreachEmailResumeUploadDropzone.on("error", (file, error) => {
      const elements = document.querySelectorAll(".dz-file-preview");
      elements.forEach((element) => {
        const filename = element.querySelector(".dz-filename span")? element.querySelector(".dz-filename span").textContent : "";
        const errorMessage = element.querySelector(".dz-error-message span");
        if (filename === file.name && errorMessage) {
          errorMessage.textContent = typeof error === "string" ? error : error.message || "Upload failed.";
        }
      });
      this.alertsAndNotificationsService.showAlert('Resume Upload Failed', 'Resume could not uploaded at this time. Please verify resume and try uploading it again.', 'danger');
    });

    return outreachEmailResumeUploadDropzone;
  }

  uploadResumes(type) {
    if (type != 'modal') {
      this.outreachEmailResumeUploadDropzone.processQueue();
    } else {
      this.outreachEmailResumeUploadDropzoneModal.processQueue();
    }
  }

  _setDateRange(experience) {
    experience.dateRange = "(";
    if (experience.startDate) {
      experience.dateRange = `${experience.dateRange}${experience.startDate.formattedMonth}, ${experience.startDate.year} -`;
    }
    if (experience.endDate) {
      experience.dateRange = `${experience.dateRange} ${experience.endDate.formattedMonth}, ${experience.endDate.year}`;
    } else {
      experience.dateRange = `${experience.dateRange}Current`;
    }
    experience.dateRange = `${experience.dateRange})`;
    if (!experience.startDate && !experience.endDate) {
      experience.dateRange = "";
    }
  }

  _getMonthByNumber(monthNumber) {
    switch (monthNumber) {
      case 1: return "Jan";
      case 2: return "Feb";
      case 3: return "Mar";
      case 4: return "Apr";
      case 5: return "May";
      case 6: return "Jun";
      case 7: return "Jul";
      case 8: return "Aug";
      case 9: return "Sep";
      case 10: return "Oct";
      case 11: return "Nov";
      case 12: return "Dec";
    }
  }

  openModal(jobId, template: TemplateRef<any>, type) {
    const config = new ModalConfig();
    const modalData: any = {};
    config.class = "custom-modal-xl custom-ngx-modal custom-candidate-job-match-modal";
    config.initialState = modalData;
    config.ignoreBackdropClick = true;
    config.backdrop = true;
    this.jobModalId = jobId;
    if (type === 'jobProfile') {
      this.showJobProfileModal = this.bsModalService.show(template, config);
    } else if (type === 'resume') {
      this.showResumeModal = this.bsModalService.show(template, config);
    } else if (type === 'upload') {
      setTimeout(() => {
        this.outreachEmailResumeUploadDropzoneModal = this.createResumeUploadDropzone("form#outreachEmailResumeUploadDropzoneModal");
      }, 500);
      this.showUploadModal = this.bsModalService.show(template, config);
    } else if (type === 'candidateContact') {
      this.showCandidateContactModal = this.bsModalService.show(template, config);
    } else if (type === 'additionalCandidateContact') {
      this.showCandidateAdditionalModal = this.bsModalService.show(template, config);
    }
  }

  closeModal(type) {
    if (type === 'jobProfile' && this.showJobProfileModal) {
      this.showJobProfileModal.hide();
    } else if (type === 'resume' && this.showResumeModal) {
      this.showResumeModal.hide();
    } else if (type === 'upload' && this.showUploadModal) {
      this.showUploadModal.hide();
    } else if (type === 'candidateContact' && this.showCandidateContactModal) {
      this.showCandidateContactModal.hide();
    } else if (type === 'additionalCandidateContact' && this.showCandidateAdditionalModal) {
      this.showCandidateAdditionalModal.hide();
    }
  }

  jobMatchOutreachStatusChanged(jobMatch) {
    this.isSubmittedFormValid = true;
    if (jobMatch.outreachStatus) {
      jobMatch.isValid = true;
    }
    this.checkAndSetFeedbackActive();
  }

  checkAndSetFeedbackActive() {
    this.isFeedbackTabActive = true;
    this.activeOutreachFeedbackClientsQuestionsList = [];
    let count = 0;
    for (const jobMatch of this.outreachObject.jobMatches) {
      if ((jobMatch.outreachStatus === 'INTERESTED' || jobMatch.outreachStatus === 'MAY_BE') && !jobMatch.isNoLongerMatch) {
        count = count + 1;
        this.activeOutreachFeedbackClientsQuestionsList.push(jobMatch.clientOrBuId);
      }
    }
    if (count > 0) {
      this.isFeedbackTabActive = false;
    }
  }

  _setJobMatchState(type, state, jobmatch) {
    if (type == 'save') {
      if (state == 'INTERESTED') {
        return 'OUTREACH_SOFT_INTERESTED';
      } else if (state == 'NOT_INTERESTED') {
        return 'OUTREACH_SOFT_NOT_INTERESTED';
      } else if (state == 'MAY_BE') {
        return 'OUTREACH_SOFT_MAYBE';
      } else {
        return null;
      }
    } else {
      if (jobmatch.isNoLongerMatch) {
        return 'NOT_MATCHED';
      }

      if (state == 'INTERESTED') {
        return 'OUTREACH_INTERESTED';
      } else if (state == 'NOT_INTERESTED') {
        return 'OUTREACH_NOT_INTERESTED';
      } else if (state == 'MAY_BE') {
        return 'OUTREACH_MAYBE';
      } else {
        return null;
      }
    }
  }

  setOutreachStatus(state) {
    if (state == 'OUTREACH_SOFT_INTERESTED' || state == 'OUTREACH_INTERESTED') {
      return 'INTERESTED';
    } else if (state == 'OUTREACH_NOT_INTERESTED' || state == 'OUTREACH_SOFT_NOT_INTERESTED') {
      return 'NOT_INTERESTED';
    } else if (state == 'OUTREACH_SOFT_MAYBE' || state == 'OUTREACH_MAYBE') {
      return 'MAY_BE';
    }
  }

  _checkIfFormValid() {
    const validStatuses = ['INTERESTED', 'NOT_INTERESTED', 'MAY_BE'];

    this.isSubmittedFormValid = this.outreachObject.jobMatches.every(jm => {
      if (!jm.jobMatchActive || jm.noLongerMatch || jm.isNoLongerMatch) {
        jm.isValid = true; // skip - consider valid for inactive job matches
        return true;
      }

      const isValid = validStatuses.indexOf(jm.outreachStatus) > -1;
      jm.isValid = isValid;
      return isValid;
    });

    return this.isSubmittedFormValid;
  }

  isOnlyOverallCommentFeedback(type): boolean {
    
    // Normal validation flow for other feedback types
    if (!this.outreachData || !this.outreachData.companyQuestionsResults) {
      return false;
    }

    // Check if clientQuestionsResults is null or empty
    let clientQuestionsEmpty = !this.outreachData.clientQuestionsResults ||
      Object.keys(this.outreachData.clientQuestionsResults).length === 0 ||
      !this.activeOutreachFeedbackClientsQuestionsList ||
      this.activeOutreachFeedbackClientsQuestionsList.length === 0;

    // Check if companyQuestionsResults has only overall comment
    let companyQuestionsOnlyOverall = false;
    let companyId = this.outreachData.candidateOutreachJobMatchesInfo ?
      this.outreachData.candidateOutreachJobMatchesInfo.jobMatches[0].companyId :
      this.companyId;

    if (this.outreachData.companyQuestionsResults[companyId] &&
      this.outreachData.companyQuestionsResults[companyId].length === 1) {
      let question = this.outreachData.companyQuestionsResults[companyId][0];
      if (question.question === 'Overall Comment') {
        companyQuestionsOnlyOverall = true;
      }
    }

    return clientQuestionsEmpty && companyQuestionsOnlyOverall;
  }

  outreachEmailSave(type) {

  const isSubmit = type === 'complete';
    const validStatuses = [
      'INTERESTED',
      'NOT_INTERESTED',
      'MAY_BE',
      'OUTREACH_INTERESTED',
      'OUTREACH_SOFT_INTERESTED',
      'OUTREACH_NOT_INTERESTED',
      'OUTREACH_SOFT_NOT_INTERESTED',
      'OUTREACH_MAYBE',
      'OUTREACH_SOFT_MAYBE'
    ];

  // SAVE (DRAFT) — NEVER BLOCK
  if (!isSubmit) {
    this.checkIfFeedbackComplete((data) => {
      this.utilityService.showLoadingModal("Saving...");
      this.updateOutreachDetails(type, data, () => {
        this.refreshOutreach(() => {
          this.resetOutreachBackupData();
          this.utilityService.hideLoadingModal();
        });
      });
    });
    return;
  }

  // 2. SUBMIT — CONTACT DETAILS REQUIRED
  if (this.isCandidateContactDetailsMissing || this.isCandidateAdditionalContactDetailsMissing) {
    const enterDetails = () => {
      // Candidate chose to enter details: just return to the screen. Do Nothing.
    };

    const submitAnyway = () => {
      // For jobMatches that are not selectable mark them as NOT_MATCHED
      // For selectable jobMatches with no selection default to OUTREACH_NOT_INTERESTED
      this.outreachObject.jobMatches.forEach(jobMatch => {

        if (jobMatch.isNoLongerMatch) {
          jobMatch.outreachStatus = 'NOT_MATCHED';
        } else if (
          !jobMatch.outreachStatus ||
          !validStatuses.includes(jobMatch.outreachStatus)
        ) {
          jobMatch.outreachStatus = 'NOT_INTERESTED';
        }

        jobMatch.isValid = true;
      });

      // Proceed with normal questions validation and submit flow
      this.checkIfFeedbackComplete((data) => {
        if (!data.isValid) {
          this.alertsAndNotificationsService.showAlertWithCallBack(
            "Incomplete Form!",
            "Please answer all the questions to update the feedback form.",
            'warning',
            () => { }
          );
          return;
        }

        this.utilityService.showLoadingModal("Saving...");
        this.updateOutreachDetails(type, data, () => {
          this.refreshOutreach(() => {
            this.resetOutreachBackupData();
            this.utilityService.hideLoadingModal();
          });
        });
      });
    };

    this.alertsAndNotificationsService.showCustomConfirm(
      'Enter Details',
      'Submit Anyway',
      'Incomplete Form!',
      'You have missing Contact and/or Additional Details. Would you like to enter the details now or submit anyway?',
      'warning',
      'medium',
      enterDetails,
      submitAnyway
    );

    return;
  }

  // 3. SUBMIT — QUESTIONS VALIDATION ONLY
  this.checkIfFeedbackComplete((data) => {

    // If questions exist and are incomplete
    if (!data.isValid) {
      this.alertsAndNotificationsService.showAlertWithCallBack(
        "Incomplete Form!",
        "Please answer all the questions to update the feedback form.",
        'warning',
        () => { }
      );
      return;
    }

    // 4. SUBMIT — DO NOT VALIDATE JOB SELECTION
    // But if the user has not selected any job statuses at all, confirm before submitting.
    const jobMatches = this.outreachObject.jobMatches || [];
    const anyNotSelected = jobMatches.some(
      jm =>
        !jm.isNoLongerMatch &&
        (!jm.outreachStatus || !validStatuses.includes(jm.outreachStatus))
    );
    const anyMatch = jobMatches.some(jm => !jm.isNoLongerMatch);

    if (anyNotSelected && anyMatch) {
      const enterDetails = () => {
        // Candidate chose to enter details: just return to the screen. Do Nothing.
      };

      const submitAnyway = () => {
        // For jobMatches that are not selectable mark them as NOT_MATCHED
        // For selectable jobMatches with no selection default to NOT_INTERESTED
        this.outreachObject.jobMatches.forEach(jobMatch => {
          if (jobMatch.isNoLongerMatch) {
            jobMatch.outreachStatus = 'NOT_MATCHED';
          } else if (!jobMatch.outreachStatus || !validStatuses.includes(jobMatch.outreachStatus)) {
            jobMatch.outreachStatus = 'NOT_INTERESTED';
          }

          jobMatch.isValid = true;
        });

        this.utilityService.showLoadingModal("Saving...");
        this.updateOutreachDetails(type, data, () => {
          this.refreshOutreach(() => {
            this.resetOutreachBackupData();
            this.utilityService.hideLoadingModal();
          });
        });
      };

      this.alertsAndNotificationsService.showCustomConfirm(
        'Enter Details',
        'Submit Anyway',
        'Alert!',
        'Some job matches have not been marked as Interested or Not Interested or May be. Would you like to enter details now or submit anyway?',
        'warning',
        'medium',
        enterDetails,
        submitAnyway
      );

      return;
    }

    this.utilityService.showLoadingModal("Saving...");
    this.updateOutreachDetails(type, data, () => {
      this.refreshOutreach(() => {
        this.resetOutreachBackupData();
        this.utilityService.hideLoadingModal();
      });
    });

  });
}


  refreshOutreach(successCallback) {
    this.outreachObjectBackup = _.cloneDeep(this.outreachObject);
    if (this.showCandidateContactModal) {
      this.showCandidateContactModal.hide();
    }

    if (this.showCandidateAdditionalModal) {
      this.showCandidateAdditionalModal.hide();
    }

    if (this.showUploadModal) {
      this.showUploadModal.hide();
    }
    
    if (this.showResumeModal) {
      this.showResumeModal.hide();
    }

    this.getOutreachDetails(() => {
      this.setOutreachData(() => {
        this.checkAndSetFeedbackActive();
        if (successCallback) {
          successCallback()
        }
      });
    });
  }

  saveCallback(type) {
    if (type === 'contact') {
      this.isContactInfoChanged = true;
    } else {
      this.isAdditionalContactInfoChanged = true;
    }
    this.utilityService.showLoadingModal("Loading...");
    this.refreshOutreach(() => {
      this.resetOutreachBackupData();
      this.utilityService.hideLoadingModal();
    });
  }

  sanitizeUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  updateOutreachDetails(type, data, successCallback) {
    let listOfClientQuestions = data.listOfClientQuestions ? data.listOfClientQuestions : [];
    let listOfCompanyQuestions = data.listOfCompanyQuestions ? data.listOfCompanyQuestions : [];
    let tempOutreachObj: any = {
      companyId: this.companyId,
      feedbackAnswersList: [...listOfClientQuestions, ...listOfCompanyQuestions],
      companyAndOverallComplete:type,
      fromButton:type
    };
    tempOutreachObj.candidateOutreachJobMatchesInfo = _.cloneDeep(this.outreachObject);
    tempOutreachObj.candidateOutreachJobMatchesInfo.jobMatches.map(jobMatch => {
      jobMatch.outreachStatus = this._setJobMatchState(type, jobMatch.outreachStatus, jobMatch);
      delete jobMatch.missingOrNonMatched;
    });
    tempOutreachObj.feedbackAnswersList.forEach(feedback => {
      feedback.id = feedback.isIdValid ? feedback.id : null;
      feedback.questionType = 'O';
    });
    tempOutreachObj.candidateUpdateConfirmation = null;
    if (type === 'save') {
      this.saveOutreachFeedbackQuestions(tempOutreachObj, type, () => {
        this.showOutreachSuccessMessage(type, false);
        if (successCallback) {
          successCallback();
        }
      });
    } else if (type === 'overallComment') {
      let overallCommitPayload = {
        companyId: this.companyId,
        feedbackAnswersList: [...listOfCompanyQuestions]
      }
      this.saveOutreachFeedbackQuestions(overallCommitPayload, type, (data) => {
        this.alertsAndNotificationsService.showAlertWithCallBack('Success', `Outreach Changes Saved as <b>Draft</b>.`, 'success', () => { });
        if (successCallback) {
          successCallback();
        }
      });
    } else {
      this.saveOutreachFeedbackQuestions(tempOutreachObj, type, (data) => {
        if (data && data.impactedOutreachJobMatchInfo && data.impactedOutreachJobMatchInfo.outreachImpactMessage && data.impactedOutreachJobMatchInfo.outreachImpactMessage != '' && data.impactedOutreachJobMatchInfo.jobMatches.length > 0) {
          data.impactedOutreachJobMatchInfo.jobMatches.forEach(jobMatch => {
            jobMatch.isValid = true;
            this.outreachService.setCompanyLocationLabel(jobMatch, this.isStaffingCompany);
            jobMatch.missingOrNonMatched = this.outreachService.setMissedOrMatchedInfo(jobMatch.missingOrNonMatchedInfo, jobMatch.workLocations);
            jobMatch.workLocationsMatchStatus = this.setWorkLocationsMatchStatus(jobMatch.missingOrNonMatchedInfo.requisitionWorkLocationModes, jobMatch.workLocations);
            jobMatch.outreachStatus = this.setOutreachStatus(jobMatch.outreachStatus);
            jobMatch.jobDetails = this.outreachService.setJobDetailsLabel(jobMatch, this.jobTypeList, this.salaryDurationOptions);
            jobMatch.candidateMatch = this.outreachService.setCandidateMatchingLabel(jobMatch);
            jobMatch.isNoLongerMatch = this.outreachService.setNoLongerMatch(jobMatch.missingOrNonMatched);
          });
          this.openJobMatchModal(data.impactedOutreachJobMatchInfo, tempOutreachObj, type);
        } else {
          this.isSavedDraft = (type == 'save' && !this.isSavedDraft) ? true : false;
          if (type == 'save') {
            this.alertsAndNotificationsService.showAlertWithCallBack('Success', `Outreach Changes Saved as <b>Draft</b>.`, 'success', () => { });
          } else {
            this.isOutreachCompleted = true;
            this.outreachResultedInNoJobMatches = data.outreachResultedInNoJobMatches;
          }
          if (successCallback) {
            successCallback();
          }
        }
      });
    }
  }

  openJobMatchModal(data, tempOutreachObj, type) {
    this.utilityService.hideLoadingModal();
    this.impactedOutreachObjectData = data;
    this.impactedOutreachObjectData.tempOutreachObj = tempOutreachObj;
    this.impactedOutreachObjectData.type = type;
    this.impactedOutreachObjectData.activeJobMatchCount = 0;
    if (this.impactedOutreachObjectData.jobMatches && this.impactedOutreachObjectData.jobMatches.length > 0) {
      // Backend 'noLongerMatch' field value takes priority over UI 'isNoLongerMatch'
      const hasActiveByStatus =
        this.impactedOutreachObjectData.jobMatches.some(
          jobMatch =>
            jobMatch.jobMatchActive &&
            !jobMatch.noLongerMatch &&
            !jobMatch.isNoLongerMatch
        );

      this.impactedOutreachObjectData.hasActiveJobs = hasActiveByStatus;
      if (!hasActiveByStatus && tempOutreachObj.candidateOutreachJobMatchesInfo && tempOutreachObj.candidateOutreachJobMatchesInfo.jobMatches) {
        this.impactedOutreachObjectData.hasActiveJobs = tempOutreachObj.candidateOutreachJobMatchesInfo.jobMatches.length !== this.impactedOutreachObjectData.jobMatches.length;
      }

      this.impactedOutreachObjectData.activeJobMatchCount = this.outreachObject.jobMatches.length - this.impactedOutreachObjectData.jobMatches.length;
    } else {
      this.impactedOutreachObjectData.hasActiveJobs = false;
    }
    const modalData = {
      outreachObject: data,
      isStaffingCompany: this.isStaffingCompany,
      jobTypeList: this.jobTypeList,
      salaryDurationOptions: this.salaryDurationOptions
    };

    let config = new ModalConfig();
    config.ignoreBackdropClick = true;
    config.backdrop = true;
    config.class = 'custom-modal-xl custom-ngx-modal custom-candidate-job-match-modal';
    config.initialState = { data: modalData };

    this.showJobMatchModal = this.bsModalService.show(this.jobMatchModal, config);
  }

  onModalResponse(modal: BsModalRef, isYes: boolean) {
    let tempOutreachObj = this.impactedOutreachObjectData.tempOutreachObj;
    if (isYes) {
      tempOutreachObj.candidateUpdateConfirmation = 'Y';
      this.utilityService.showLoadingModal("Saving...");
      this.saveOutreachFeedbackQuestions(tempOutreachObj, this.impactedOutreachObjectData.type, (data) => {
        this.showOutreachSuccessMessage(this.impactedOutreachObjectData.type, isYes);
        this.refreshOutreach(() => {
          this.resetOutreachBackupData();
          this.utilityService.hideLoadingModal();
        });
      });
      modal.hide();
    } else {
      tempOutreachObj.candidateUpdateConfirmation = 'N';
      this.alertsAndNotificationsService.showCustomConfirm('Review', 'Undo', 'Alert!', 'Do you want to undo your Contact and Additional Detail changes?', 'warning', 'medium', () => {
        modal.hide();
      }, () => {
        this.utilityService.showLoadingModal("Saving...");
        this.saveOutreachFeedbackQuestions(tempOutreachObj, this.impactedOutreachObjectData.type, (data) => {
          this.showOutreachSuccessMessage(this.impactedOutreachObjectData.type, isYes);
          this.refreshOutreach(() => {
            this.resetOutreachBackupData();
            this.utilityService.hideLoadingModal();
          });
        });
        modal.hide();
      });
    }
  }


  showOutreachSuccessMessage(type, isYes) {
    this.isSavedDraft = (type == 'save' && !this.isSavedDraft) ? true : false;
    if (type == 'save') {
      this.alertsAndNotificationsService.showAlertWithCallBack('Success', `Outreach Changes Saved as <b>Draft</b>.`, 'success', () => { });
    } else {
      if (isYes) {
        this.isOutreachCompleted = true;
        this.outreachResultedInNoJobMatches = this.outreachData.outreachResultedInNoJobMatches;
      } else {
        this.alertsAndNotificationsService.showAlertWithCallBack('Success', 'The changes made to the contact/additional details have been reverted successfully', 'success', () => { });
      }
    }
  }

  saveOutreachFeedbackQuestions(tempOutreachObj, type, successCallback) {
    this.outreachService.saveOutreachFeedbackQuestions(tempOutreachObj, this.candidateId, this.companyId, (data) => {
      if (successCallback) {
        successCallback(data);
      }
    }, (error) => {
      let link = 'https://prod.4dot5.com/#/authenticateToken?a=Outreach&t=' + this.tokenId + '&cid=' + this.candidateId + '&comp=' + this.companyId;
      if (error.message == 'Your Outreach link has expired and is no longer valid.') {
          // Logout if link expires When Save, Submit Button Clicked.
          this.logoutAndRedirectToLogin();
          this.utilityService.hideLoadingModal();
          setTimeout(() => {
            window.location.href = link;
          },300);
      } else { 
        this.utilityService.hideLoadingModal();
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    });
  }

  checkIfFeedbackComplete(successCallback) {
    this.feedbackExecutionComponentRef.saveOutreachFeedback((data) => {
      if (successCallback) {
        successCallback(data);
      }
    });
  }

  setMissingDetailsIcons(candidate) {
    this.isCandidateContactDetailsMissing = !this.sharedService.isContactDetailsAvailable(this.candidate, 'candidateCard');
    this.isCandidateAdditionalContactDetailsMissing = !this.sharedService.isCandidateAdditionalDetailsAvailable(this.candidate);
  }

  resetOutreachBackupData() {
    const backupMap = new Map<number, string>();
    this.outreachObjectBackup.jobMatches.forEach(val => {
      backupMap.set(val.jobId, val.outreachStatus);
    });

    this.outreachObject.jobMatches.forEach(jobMatch => {
      // 'isNoLongerMatch' as per UI check for contact and additional contact details missing. 'noLongerMatch' is from backend.
      if (!jobMatch.jobMatchActive || jobMatch.noLongerMatch || jobMatch.isNoLongerMatch) {
        return; // skip inactive job matches
      }

      const backupStatus = backupMap.get(jobMatch.jobId);

      if (backupStatus !== undefined) {
        jobMatch.outreachStatus =
          (!jobMatch.outreachStatus || jobMatch.outreachStatus === '')
            ? backupStatus
            : jobMatch.outreachStatus;
      }
    });

    this.checkAndSetFeedbackActive();
  }

  logoutAndRedirectToLogin() {
    this.StorageService.resetBrowserStorage();
    this.StorageService.removeCookie('connect.sid');
    this.StorageService.remove('companyDetails');
    this.StorageService.remove('SelectedHostCompany');
    this.StorageService.remove('userDetails');
  }

  _showConflictsModal(conflicts) {
    this.candidateConflictDetails = _.cloneDeep(conflicts);
    this._setFieldsForConflicts();
    const config = new ModalConfig();
    config.ignoreBackdropClick = true;
    config.backdrop = true;
    config.class = 'custom-modal-xl custom-ngx-modal';
    this.conflictsModalRef = this.bsModalService.show(this.conflictsModal, config);
  }

  _setFieldsForConflicts() {
    if (!this.candidateConflictDetails || !this.candidateConflictDetails.candidateConflictDetails) return;
    this.candidateConflictDetails.candidateConflictDetails.forEach(conflict => {
      conflict.fieldId = (conflict.fieldName || '').split(' ').join('-');
      conflict.selectedValue = conflict.newValue;
      conflict.newValueSelected = true;
    });
  }

  _submitContactDetailsViaScoring(contactDetails: any, isUpdate: boolean) {
    this.uploadResumesResponse.candidateContactDetail = contactDetails;
    if (!this.uploadResumesResponse.file && this.uploadResumesResponse.files && this.uploadResumesResponse.files.length > 0) {
      this.uploadResumesResponse.file = this.uploadResumesResponse.files[0];
    }

    if (!this.uploadResumesResponse.sourceScreen) {
        this.uploadResumesResponse.sourceScreen = 'OUTREACH';
    }

    this.utilityService.showLoadingModal('Saving...');
    this.resumeService.runResumeScoringForAssociate(this.uploadResumesResponse, this.candidateId, this.jobId, isUpdate, (data) => {
      if (this.conflictsModalRef) this.conflictsModalRef.hide();
      this.utilityService.hideLoadingModal();
      if (isUpdate) {
        $(".dz-hidden-input").prop("disabled", true);
        this.isSingleResumeUploadDone = true;
        this.isSingleResumeUploadedInPreviousSession = false;
        this.alertsAndNotificationsService.showAlertWithCallBack('Success', 'Resume details updated successfully.', 'success', () => {
          this.utilityService.showLoadingModal('Loading...');
          this.refreshOutreach(() => {
            this.resetOutreachBackupData();
            this.utilityService.hideLoadingModal();
          });
        });
      } else {
        this.alertsAndNotificationsService.showAlertWithCallBack('Update Cancelled', 'Resume update cancelled. No changes were made to the resume details.', 'info', () => {
          this.utilityService.showLoadingModal('Loading...');
          this.refreshOutreach(() => {
            this.resetOutreachBackupData();
            this.utilityService.hideLoadingModal();
            // Remove any existing file(s) from the Dropzone instance to clear previews
            if (this.outreachEmailResumeUploadDropzone && this.outreachEmailResumeUploadDropzone.files && this.outreachEmailResumeUploadDropzone.files.length > 0) {
              this.outreachEmailResumeUploadDropzone.removeAllFiles(true);
              this.fileExistsFlag = false;
            }

            if (this.outreachEmailResumeUploadDropzoneModal && this.outreachEmailResumeUploadDropzoneModal.files && this.outreachEmailResumeUploadDropzoneModal.files.length > 0) {
              this.outreachEmailResumeUploadDropzoneModal.removeAllFiles(true);
              this.fileExistsFlag = false;
            }
          });
        });
      }
    }, (error) => {
      this.utilityService.hideLoadingModal();
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  onConflictRadioChange(index, newValueSelected) {
    const field = this.candidateConflictDetails.candidateConflictDetails[index];
    field.selectedValue = newValueSelected ? field.newValue : field.oldValue;
    field.newValueSelected = !!newValueSelected;
  }

  saveConflicts() {
    const fields = this.candidateConflictDetails.candidateConflictDetails;
    const contactDetails = {
      firstName: fields[0] ? fields[0].selectedValue : null,
      lastName: fields[1] ? fields[1].selectedValue : null,
      email: fields[2] ? fields[2].selectedValue : null,
      phoneNumber: fields[3] ? fields[3].selectedValue : null,
      source: 'resume'
    };

    this._submitContactDetailsViaScoring(contactDetails, true);
  }

  cancelConflicts() {
    if (!this.candidateConflictDetails || !this.candidateConflictDetails.candidateConflictDetails) return;
    const fields = this.candidateConflictDetails.candidateConflictDetails;
    const contactDetails = {
      firstName: fields[0] ? fields[0].selectedValue : null,
      lastName: fields[1] ? fields[1].selectedValue : null,
      email: fields[2] ? fields[2].selectedValue : null,
      phoneNumber: fields[3] ? fields[3].selectedValue : null,
      source: 'resume'
    };

    this._submitContactDetailsViaScoring(contactDetails, false);
  }

  }
